__turbopack_context__.v({
  "blockLevelReference": "loginOrSignUpPopover-module-scss-module__mdtDoq__blockLevelReference",
  "loginButton": "loginOrSignUpPopover-module-scss-module__mdtDoq__loginButton",
  "popover": "loginOrSignUpPopover-module-scss-module__mdtDoq__popover",
  "popoverArrow": "loginOrSignUpPopover-module-scss-module__mdtDoq__popoverArrow",
  "popoverContainer": "loginOrSignUpPopover-module-scss-module__mdtDoq__popoverContainer",
  "popoverDescription": "loginOrSignUpPopover-module-scss-module__mdtDoq__popoverDescription",
});
